const REQUEST_KIOSK_MONITORING_ACTIONS = "REQUEST_KIOSK_MONITORING_ACTIONS";
const RECEIVE_KIOSK_MONITORING_ACTIONS = "RECEIVE_KIOSK_MONITORING_ACTIONS";

export default {
    REQUEST_KIOSK_MONITORING_ACTIONS, 
    RECEIVE_KIOSK_MONITORING_ACTIONS
}